/* ============================================================
   Catia Creative — lean theme JS
   Header search, cart drawer, personalizer modal, cart AJAX.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Header search ---------- */
  function initSearch() {
    var panel = $('[data-cc-search-panel]');
    if (!panel) return;
    $$('[data-cc-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) {
          panel.removeAttribute('hidden');
          var input = $('[data-cc-search-input]', panel);
          if (input) setTimeout(function () { input.focus(); }, 50);
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null;
  function openDrawer() {
    drawer = drawer || $('[data-cc-cart-drawer]');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { if (drawer) drawer.setAttribute('hidden', ''); }, 350);
  }
  function initDrawer() {
    drawer = $('[data-cc-cart-drawer]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-cart-open]')) { e.preventDefault(); openDrawer(); }
      if (e.target.closest('[data-cc-cart-close]')) { e.preventDefault(); closeDrawer(); }
      var qtyBtn = e.target.closest('[data-cc-qty]');
      if (qtyBtn) {
        var wrap = qtyBtn.closest('.cc-qty');
        var key = wrap && wrap.getAttribute('data-key');
        var current = parseInt(wrap.querySelector('span').textContent, 10) || 0;
        var next = qtyBtn.getAttribute('data-cc-qty') === 'plus' ? current + 1 : current - 1;
        if (key) CCCart.change(key, Math.max(0, next));
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closePersonalizer(); } });
  }

  /* ---------- Cart AJAX ---------- */
  var CCCart = {
    add: function (payload) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); }).then(function (res) {
        return CCCart.refresh().then(function () { openDrawer(); return res; });
      });
    },
    change: function (key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function () { return CCCart.refresh(); });
    },
    /* Phase 1 refresh: re-fetch current page and swap the drawer body + count.
       Phase 3 will replace this with the Section Rendering API for less payload. */
    refresh: function () {
      return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'cc' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-cc-cart-body]', '[data-cc-cart-count]'].forEach(function (sel) {
            var nu = doc.querySelector(sel), cur = $(sel);
            if (nu && cur) cur.innerHTML = nu.innerHTML;
          });
          var count = doc.querySelector('[data-cc-cart-count]');
          if (count) {
            var cur = $('[data-cc-cart-count]');
            if (cur) { cur.textContent = count.textContent; cur.classList.toggle('is-empty', count.textContent.trim() === '0'); }
          }
          var foot = doc.querySelector('.cc-drawer__foot'), body = $('[data-cc-cart-body]');
          var curFoot = $('.cc-drawer__foot');
          if (curFoot) curFoot.remove();
          if (foot && body && body.parentNode) body.parentNode.appendChild(foot);
        });
    }
  };
  window.CCCart = CCCart;

  /* ---------- Personalizer modal ----------
     Opens the personalizer in an iframe. Listens for a completion message:
       { source: 'catia-personalizer', event: 'complete', ref, summary }
     and re-broadcasts it as a DOM event 'cc:personalize:complete'. */
  var modal = null, personalizerOrigin = null;
  function openPersonalizer(url) {
    modal = modal || $('[data-cc-personalizer]');
    if (!modal || !url) return;
    try { personalizerOrigin = new URL(url).origin; } catch (e) { personalizerOrigin = null; }
    var frame = $('[data-cc-personalizer-frame]', modal);
    frame.src = url;
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closePersonalizer() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    var frame = $('[data-cc-personalizer-frame]', modal);
    setTimeout(function () { if (modal) { modal.setAttribute('hidden', ''); if (frame) frame.src = 'about:blank'; } }, 250);
  }
  function initPersonalizer() {
    modal = $('[data-cc-personalizer]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-personalizer-close]')) { e.preventDefault(); closePersonalizer(); }
    });
    window.addEventListener('message', function (e) {
      if (personalizerOrigin && e.origin !== personalizerOrigin) return;
      var d = e.data || {};
      if (d.source !== 'catia-personalizer') return;
      if (d.event === 'complete') {
        document.dispatchEvent(new CustomEvent('cc:personalize:complete', { detail: d }));
        closePersonalizer();
      } else if (d.event === 'close') {
        closePersonalizer();
      }
    });
  }
  window.CCPersonalizer = { open: openPersonalizer, close: closePersonalizer };

  document.addEventListener('DOMContentLoaded', function () {
    initSearch();
    initDrawer();
    initPersonalizer();
  });
})();
